import { useCallback } from "react";

import * as MutationRepository from "@/components/features/dialog/re-onboarding-request/repository/mutation";

import type * as FormModelType from "../type";

export const useSendReOnboardingRequest = (
	inputModel: FormModelType.ReOnboardingRequestFormModel["InputModel"],
	onResetViewModel: () => void,
) => {
	const { onSendReOnboardingRequest: _onSendReOnboardingRequest } =
		MutationRepository.useReOnboardingRequestMutation();

	const onSendReOnboardingRequest = useCallback(() => {
		_onSendReOnboardingRequest(inputModel);
		onResetViewModel();
	}, [inputModel, _onSendReOnboardingRequest, onResetViewModel]);

	return {
		onSendReOnboardingRequest,
	};
};
